import { snackbarSlice } from './slice';

export const { addSnackbar, removeSnackbar } = snackbarSlice.actions;
